import React, { useEffect } from 'react'
import { Button, Form, Input, Select, Row, Col, Modal } from 'antd'

// mobx
import { useStore } from '@/store'
import { set, runInAction, toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
// mobx

//经度纬度
import Getlnglat from '@/components/Getlnglat'

import { validatLength, validatLength2, validatePhone, validate } from '@/utils/check'
import { SelectAreacode } from '@/components'

const EnterpriseInput = ({ title }) => {
  const { EnterpriseStore } = useStore()
  //获得table数据
  useEffect(() => {
    EnterpriseStore.provinceLinkage()
    // eslint-disable-next-line
  }, [])
  // 取消按钮
  const [form] = Form.useForm()
  //经度纬度
  const getGetlnglat = (value) => {
    form.setFieldsValue({
      jd: value[0],
      wd: value[1],
    });
  }
  //点X取消
  const handleOk = () => {
    runInAction(() => {
      set(EnterpriseStore, { isJdWd: false })
    })
  };
  const getAddRole = () => {
    runInAction(() => {
      set(EnterpriseStore, { isJdWd: true })
    })
  }

  //五级联动
  const province = async (value) => {
    await EnterpriseStore.cityLinkage(value)
    runInAction(() => {
      set(EnterpriseStore, { provinceValue: value })
    })
  }
  const city = async (value) => {
    await EnterpriseStore.countyLinkage(value)
    runInAction(() => {
      set(EnterpriseStore, { cityValue: value })
    })

  }
  const county = async (value) => {
    await EnterpriseStore.townshipLinkage(value)
    runInAction(() => {
      set(EnterpriseStore, { countyValue: value })
    })

  }
  const township = async (value) => {
    await EnterpriseStore.villageLinkage(value)
    runInAction(() => {
      set(EnterpriseStore, { townshipValue: value })
    })

  }
  const village = async (value) => {
    runInAction(() => {
      set(EnterpriseStore, { villageValue: value })
    })
  }

  //表单提交
  const onFinish = async (values) => {
    if (title === '添加') {
      // values.AreaCode = JSON.stringify(EnterpriseStore.villageValue)
      await EnterpriseStore.getAddButtom(values)
    } else if (title === '编辑') {
      // values.AreaCode = JSON.stringify(EnterpriseStore.villageValue)
      await EnterpriseStore.getPutInformation(values)
    }
    runInAction(() => {
      set(EnterpriseStore, { isActive: false })
    })
    form.resetFields()
  };
  const onFormLayoutChange = (x, value) => {
    if (Object.keys(x)[0] === "province") {
      form.setFieldsValue({ city: undefined, county: undefined, township: undefined, village: undefined });
    }
    if (Object.keys(x)[0] === "city") {
      form.setFieldsValue({ county: undefined, township: undefined, village: undefined });
    }
    if (Object.keys(x)[0] === "county") {
      form.setFieldsValue({ township: undefined, village: undefined });
    }
    if (Object.keys(x)[0] === "township") {
      form.setFieldsValue({ village: undefined });
    }
  };
  return (
    <>
      {
        title === '添加' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          onValuesChange={onFormLayoutChange}
          initialValues={{

          }}
        >
          <Form.Item label="所属系统" name='jrxtid'
            rules={[
              {
                required: true,
                message: '所属系统',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(EnterpriseStore.selectList)}>
            </Select>
          </Form.Item>
          <Form.Item label="企业名称" name="qymc" rules={[
            {
              required: true,
              message: '请输入企业名称',
            },
            {
              validator: validatLength2
            }
          ]}>
            <Input placeholder="请输入企业名称" />
          </Form.Item>

          <Form.Item label="法人名称" name="frxm" rules={[
            {
              required: true,
              message: '请输入法人名称',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入法人名称" />
          </Form.Item>
          <Form.Item label="法人联系电话" name="frlxdh" rules={[
            { required: true, message: '请输入手机号' },
            {
              validator: validatePhone
            }
          ]}>
            <Input placeholder="请输入法人联系电话" />
          </Form.Item>
          <Form.Item label="联系人" name="lxr" rules={[
            {
              required: true,
              message: '请输入联系人',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入联系人名称" />
          </Form.Item>
          <Form.Item label="联系人电话" name="lxdh" rules={[
            { required: true, message: '请输入手机号' },
            {
              validator: validatePhone
            }
          ]}>
            <Input placeholder="请输入联系人电话" />
          </Form.Item>
          <Form.Item label="选择地区" name="AreaCode" rules={[
            { required: true, message: '请选择' },

          ]}>
            <SelectAreacode />
          </Form.Item>
          {/* <Form.Item label={<div><i style={{ color: 'red' }}>* </i>选择地区</div>}>

            <Form.Item name='province' noStyle rules={[
              {
                required: true,
                message: '请输入省',
              }
            ]}>
              <Select
                placeholder='省'
                onChange={province}
                options={toJS(EnterpriseStore.province)}
                style={{ width: '98px', marginRight: '6px', marginBottom: '5px' }}

              />
            </Form.Item>
            <Form.Item name="city" noStyle rules={[
              {
                required: true,
                message: '请输入市',
              }
            ]}>
              <Select
                placeholder='市'
                onChange={city}
                style={{ width: '98px', marginRight: '6px', marginBottom: '5px' }}
                options={toJS(EnterpriseStore.city)}
              />
            </Form.Item>
            <Form.Item name="county" noStyle rules={[
              {
                required: true,
                message: '请输入县',
              }
            ]}>
              <Select
                placeholder='县'
                onChange={county}
                style={{ width: '98px', marginRight: '6px', marginBottom: '5px' }}
                options={toJS(EnterpriseStore.county)}
              />
            </Form.Item>
            <Form.Item name='township' noStyle rules={[
              {
                required: true,
                message: '请输入乡',
              }
            ]}>
              <Select
                placeholder='乡'
                onChange={township}
                options={toJS(EnterpriseStore.township)}
                style={{ width: '98px', marginRight: '6px' }}
              />
            </Form.Item>
            <Form.Item name='village' noStyle rules={[
              {
                required: true,
                message: '请输入村',
              }
            ]}>
              <Select
                placeholder='村'
                onChange={village}
                options={toJS(EnterpriseStore.village)}
                style={{ width: '98px' }}
              />
            </Form.Item>
          </Form.Item> */}
          <Form.Item label={<div><i style={{ color: 'red' }}>* </i>地理坐标</div>}>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item noStyle name="jd" rules={[
                  { required: true, message: '请输入经度' },
                  {
                    validator: validate
                  }
                ]}>
                  <Input placeholder="经度" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item noStyle name="wd"
                  rules={[
                    { required: true, message: '请输入纬度' },
                    {
                      validator: validate
                    }
                  ]}>
                  <Input placeholder="纬度" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Button type='primary' onClick={getAddRole}>获取坐标</Button>
              </Col>
            </Row>
          </Form.Item>
          <Modal
            title="获取坐标"
            bodyStyle={{ padding: '0' }}
            key={new Date()}
            width="800px"
            open={EnterpriseStore.isJdWd}
            onCancel={handleOk}
            footer={[
              <Button key="submit" type="primary" onClick={handleOk}>
                确认
              </Button>,
            ]}
          >
            <Getlnglat height='600px' value={[EnterpriseStore.valueData.jd, EnterpriseStore.valueData.wd]} onChange={getGetlnglat} />
          </Modal>
          <Form.Item label="经营范围" name="jyfw" rules={[
            {
              required: true,
              message: '请输入经营范围',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item label="企业地址" name="qydz" rules={[
            {
              required: true,
              message: '请输入企业地址',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item label="备注信息" name="bz" rules={[
            {
              required: true,
              message: '请输入备注信息',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              立即添加
            </Button>
          </Form.Item>
        </Form>
      }
      {
        title === '编辑' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          onValuesChange={onFormLayoutChange}
          // initialValues={toJS(EnterpriseStore.valueData)}
          initialValues={{ ...EnterpriseStore.valueData, province: EnterpriseStore.valueData.diqu[0], city: EnterpriseStore.valueData.diqu[1], county: EnterpriseStore.valueData.diqu[2], township: EnterpriseStore.valueData.diqu[3], village: EnterpriseStore.valueData.diqu[4] }}
        >
          {
            console.log(toJS(EnterpriseStore.valueData.diqu[0]), '55')
          }
          <Form.Item label="所属系统" name='jrxtid'
            rules={[
              {
                required: true,
                message: '所属系统',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(EnterpriseStore.selectList)}>
            </Select>
          </Form.Item>
          <Form.Item label="企业名称" name="qymc" rules={[
            {
              required: true,
              message: '请输入企业名称',
            },
            {
              validator: validatLength2
            }
          ]}>
            <Input placeholder="请输入企业名称" />
          </Form.Item>

          <Form.Item label="法人名称" name="frxm" rules={[
            {
              required: true,
              message: '请输入法人名称',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入法人名称" />
          </Form.Item>
          <Form.Item label="法人联系电话" name="frlxdh" rules={[
            { required: true, message: '请输入手机号' },
            {
              validator: validatePhone
            }
          ]}>
            <Input placeholder="请输入法人联系电话" />
          </Form.Item>
          <Form.Item label="联系人" name="lxr" rules={[
            {
              required: true,
              message: '请输入联系人',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入联系人名称" />
          </Form.Item>
          <Form.Item label="联系人电话" name="lxdh"
            rules={[
              { required: true, message: '请输入手机号' },
              {
                validator: validatePhone
              }
            ]}>
            <Input placeholder="请输入联系人电话" />
          </Form.Item>
          <Form.Item label="选择地区" name="AreaCode" rules={[
            { required: true, message: '请选择' },

          ]}>
            <SelectAreacode />
          </Form.Item>
          {/* <Form.Item label={<div><i style={{ color: 'red' }}>* </i>选择地区</div>}>

            <Form.Item name='province' noStyle rules={[
              {
                required: true,
                message: '请输入省',
              }
            ]}>
              <Select
                placeholder='省'
                onChange={province}
                options={toJS(EnterpriseStore.province)}
                style={{ width: '98px', marginRight: '6px', marginBottom: '5px' }}

              />
            </Form.Item>
            <Form.Item name="city" noStyle rules={[
              {
                required: true,
                message: '请输入市',
              }
            ]}>
              <Select
                placeholder='市'
                onChange={city}
                style={{ width: '98px', marginRight: '6px', marginBottom: '5px' }}
                options={toJS(EnterpriseStore.city)}
              />
            </Form.Item>
            <Form.Item name="county" noStyle rules={[
              {
                required: true,
                message: '请输入县',
              }
            ]}>
              <Select
                placeholder='县'
                onChange={county}
                style={{ width: '98px', marginRight: '6px', marginBottom: '5px' }}
                options={toJS(EnterpriseStore.county)}
              />
            </Form.Item>
            <Form.Item name='township' noStyle rules={[
              {
                required: true,
                message: '请输入乡',
              }
            ]}>
              <Select
                placeholder='乡'
                onChange={township}
                options={toJS(EnterpriseStore.township)}
                style={{ width: '98px', marginRight: '6px' }}
              />
            </Form.Item>
            <Form.Item name='village' noStyle rules={[
              {
                required: true,
                message: '请输入村',
              }
            ]}>
              <Select
                placeholder='村'
                onChange={village}
                options={toJS(EnterpriseStore.village)}
                style={{ width: '98px' }}
              />
            </Form.Item>
          </Form.Item> */}
          <Form.Item label={<div><i style={{ color: 'red' }}>* </i>地理坐标</div>}>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item noStyle name="jd" rules={[
                  { required: true, message: '请输入经度' },
                  {
                    validator: validate
                  }
                ]}>
                  <Input placeholder="经度" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item noStyle name="wd"
                  rules={[
                    { required: true, message: '请输入纬度' },
                    {
                      validator: validate
                    }
                  ]}>
                  <Input placeholder="纬度" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Button type='primary' onClick={getAddRole}>获取坐标</Button>
              </Col>
            </Row>
          </Form.Item>
          <Modal
            title="获取坐标"
            bodyStyle={{ padding: '0' }}
            key={new Date()}
            width="800px"
            open={EnterpriseStore.isJdWd}
            onCancel={handleOk}
            footer={[
              <Button key="submit" type="primary" onClick={handleOk}>
                确认
              </Button>,
            ]}
          >
            <Getlnglat height='600px' value={[EnterpriseStore.valueData.jd, EnterpriseStore.valueData.wd]} onChange={getGetlnglat} />
          </Modal>
          <Form.Item label="经营范围" name="jyfw" rules={[
            {
              required: true,
              message: '请输入经营范围',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item label="企业地址" name="qydz" rules={[
            {
              required: true,
              message: '请输入企业地址',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item label="备注信息" name="bz" rules={[
            {
              required: true,
              message: '请输入备注信息',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              修改内容
            </Button>
          </Form.Item>
        </Form>
      }
      {
        title === '查看' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={toJS(EnterpriseStore.valueData)}
        >
          <Form.Item label="所属系统" >
            {EnterpriseStore.valueData.xtmc}
          </Form.Item>
          <Form.Item label="企业名称" >
            {EnterpriseStore.valueData.qymc}
          </Form.Item>
          <Form.Item label="法人名称" >
            {EnterpriseStore.valueData.frxm}
          </Form.Item>
          <Form.Item label="法人联系电话" >
            {EnterpriseStore.valueData.frlxdh}
          </Form.Item>
          <Form.Item label="联系人" >
            {EnterpriseStore.valueData.xtmc}
          </Form.Item>
          <Form.Item label="联系人电话" >
            {EnterpriseStore.valueData.lxdh}
          </Form.Item>
          <Form.Item label="地区" >
            {EnterpriseStore.valueData.diqu[0]}-{EnterpriseStore.valueData.diqu[1]}-{EnterpriseStore.valueData.diqu[2]}-{EnterpriseStore.valueData.diqu[3]}-{EnterpriseStore.valueData.diqu[4]}
          </Form.Item>
          <Form.Item label="地理坐标" >
            {EnterpriseStore.valueData.jd}-{EnterpriseStore.valueData.wd}
          </Form.Item>
          <Form.Item label="经营范围" >
            {EnterpriseStore.valueData.jyfw}
          </Form.Item>
          <Form.Item label="企业地址" >
            {EnterpriseStore.valueData.qydz}
          </Form.Item>
          <Form.Item label="备注信息" >
            {EnterpriseStore.valueData.bz}
          </Form.Item>
        </Form>
      }
    </>
  )
}

export default observer(EnterpriseInput)